import { SUMMARY_PROGRESS_VIEW } from '@/fixtures'

export default {
  path: 'summary-progress',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Summary Progress',
      component: () => import('@/views/menus/SummaryProgress/Index'),
      meta: {
        permission: SUMMARY_PROGRESS_VIEW
      }
    },
    {
      path: 'detail',
      name: 'Report Summary Progress',
      component: () => import('@/views/menus/SummaryProgress/View'),
      meta: {
        permission: SUMMARY_PROGRESS_VIEW
      }
    }
  ]
}
